module.exports = __webpack_public_path__ + "static/media/skypeople.1136b385.png";